import React, { Component } from 'react';
import Lander from './DestiLander';
import Section from './Section';
import FeaturedSection from './FeaturedSection';
import '../css/style.css.scss';
import { segmentTrackEvent, scrollToTopOf } from '../utils';

class Destination extends Component {
  constructor() {
    super();
  }

  render() {
    // the shape of the destructured this.props object will match the shape of the object in destination-data.js
    const {
      id,
      lander,
      sections,
      pinkImage,
      isMobile,
    } = this.props;
    const body = document.getElementsByTagName("body")[0];

    const ctaTracker = {
      module: 'destination',
      category: 'scroll-to-top',
      linkType: 'scroll-to-top',
      label: 'back-to-top',
    };

    const renderedSections = sections.map((section, i) => {
      if (section.shoppable) {
        return (
          <FeaturedSection
            key={i}
            section={section}
            sectionIndex={i}
            isMobile={isMobile}
            pinkImage={pinkImage} />
        )
      } else {
        return (
            <Section
            key={i}
            num={i+1}
            section={section}
            sectionIndex={i}
            isMobile={isMobile} 
            pinkImage={pinkImage} />
        )
      }
    });

    return (
      <div id={id} className="desti-main">
        <Lander {...lander} isMobile={isMobile} />
        { renderedSections }
        <div className="back-to-top" onClick={() => { scrollToTopOf(body); segmentTrackEvent('back_to_top_clicked', ctaTracker); }}>back to top</div>    
      </div>
    );
  }
}

export default Destination;
